var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.732,
    height: 23.055,
    viewBox: "0 0 18.732 23.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.931,2.882H60.969v-.72A2.161,2.161,0,0,0,58.807,0H55.925a2.161,2.161,0,0,0-2.161,2.161v.72H49.8a1.8,1.8,0,0,0-1.8,1.8V6.124a.72.72,0,0,0,.72.72H66.012a.72.72,0,0,0,.72-.72V4.683A1.8,1.8,0,0,0,64.931,2.882ZM55.2,2.161a.721.721,0,0,1,.72-.72h2.882a.721.721,0,0,1,.72.72v.72H55.2Z",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.589,184a.225.225,0,0,0-.225.236l.594,12.475a2.159,2.159,0,0,0,2.159,2.059H87.059a2.159,2.159,0,0,0,2.159-2.059l.594-12.475a.225.225,0,0,0-.225-.236Zm10.881,1.8a.72.72,0,0,1,1.441,0v9.366a.72.72,0,1,1-1.441,0Zm-3.6,0a.72.72,0,0,1,1.441,0v9.366a.72.72,0,1,1-1.441,0Zm-3.6,0a.72.72,0,0,1,1.441,0v9.366a.72.72,0,1,1-1.441,0Z",
    transform: "translate(-24.222 -175.715)",
    fill: "#697384"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e6feeea3e67b4960d3abf25dda3e39f0.svg";
export { ForwardRef as ReactComponent };